import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { EmptyListing, EditModal, DeleteModal, MarkSoldModal, Ticket } from './components';
import './style';
import { getUserListing } from './api';
import { useSelector } from 'react-redux';
import { convertCustomDateFormatToISO } from '../../utils/commonUtils';

const UserListing = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMarkSoldModal, setShowMarkSoldModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const { tickets } = useSelector((state) => state.userListing);

  useEffect(() => {
    getUserListing();
  }, []);

  const handleEditClick = (ticket) => {
    setSelectedTicket(ticket);
    setShowEditModal(true);
  };

  const handleDeleteClick = (ticket) => {
    setSelectedTicket(ticket);
    setShowDeleteModal(true);
  };

  const handleMarkSoldClick = (ticket) => {
    setSelectedTicket(ticket);
    setShowMarkSoldModal(true);
  };
  const handleUpdate = () => getUserListing();

  // convertCustomDateFormatToISO(ticket?.event?.payload?.start_date || new Date()) < new Date();
  const isPastEvent = (ticket) => (ticket?.isSold || ticket?.isExpiry) && !ticket?.isDeleted;

  const activeTickets = tickets.filter((ticket) => !isPastEvent(ticket) && !ticket?.isDeleted);
  const pastTickets = tickets.filter(isPastEvent);

  return (
    <div className="user-listing-wrapper min-h-screen flex-1 overflow-auto p-6 py-8 md:py-6 w-[100%] flex flex-col items-start md:w-[45%] md:items-center md:m-auto md:mt-[100px] mt-[100px]">
      <Helmet>
        <title>My Listings</title>
        <meta
          name="title"
          content="Manage Your Event Ticket Listings in India | Take My Tickets"
        />
        <meta
          name="description"
          content="Easily manage and update your event ticket listings on Take My Tickets. Sell your tickets with confidence to the Indian audience."
        />
      </Helmet>

      <div className="user-listing-container w-[100%]  md:items-center">
        <div className="flex flex-col gap-9 w-[100%]">
          <div className="heading-36 md:pt-6">My listings</div>
          {activeTickets.length > 0 && (
            <div className="flex flex-col heading-24">Active Listings</div>
          )}
          {activeTickets.length > 0 ? (
            activeTickets.map((ticket) => (
              <div className="flex flex-col gap-6"
                key={ticket._id}>
                <Ticket
                  {...ticket}
                  isEventLive={!isPastEvent(ticket)}
                  onEditClick={() => handleEditClick(ticket)}
                  onDeleteClick={() => handleDeleteClick(ticket)}
                  onMarkSoldClick={() => handleMarkSoldClick(ticket)}
                />
              </div>
            ))
          ) : (
            <EmptyListing />
          )}
          {pastTickets.length > 0 && (
            <div className="heading-24 pt-6">Past Listings</div>
          )}
          {pastTickets.map((ticket) => (
            <Ticket
              key={ticket._id}
              {...ticket}
              isEventLive={false}
              onMarkSoldClick={() => handleMarkSoldClick(ticket)}
            />
          ))}
        </div>
      </div>
      {showEditModal && (
        <EditModal
          ticket={selectedTicket}
          onClose={() => setShowEditModal(false)}
          onDelete={() => setShowDeleteModal(true)}
          onUpdate={handleUpdate}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          listingId={selectedTicket._id}
          ticket={selectedTicket}
          onClose={() => { handleUpdate(); setShowDeleteModal(false); setShowEditModal(false); }}
        />
      )}
      {showMarkSoldModal && (
        <MarkSoldModal
          listingId={selectedTicket._id}
          ticket={selectedTicket}
          onClose={() => { handleUpdate(); setShowMarkSoldModal(false); }}
        />
      )}
    </div>
  );
};

export default UserListing;

